<div class="edit-form">
  <div class="form-header">
    <h2 *ngIf="isEdit && !isDependent">Edit Member Information</h2>
    <h2 *ngIf="!isEdit && !isDependent">Add New Member</h2>
    <h2 *ngIf="!isEdit && isDependent">Add New Dependent</h2>
    <h2 *ngIf="isEdit && isDependent">Edit Dependent Information</h2>
    <button class="close-btn" type="button" (click)="onClose()">x</button>
  </div>
  <form [formGroup]="memberForm" class="form-grid" (ngSubmit)="onSave()">
    <label>
      ID Number
      <input
        type="text"
        formControlName="idNumber"
        placeholder="Enter ID Number"
        required
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('idNumber')?.invalid &&
          memberForm.get('idNumber')?.touched
        "
      >
        ID Number is required
      </div>
    </label>

    <label>
      Date of Birth
      <input type="date" formControlName="dateOfBirth" required />
      <div
        class="error"
        *ngIf="
          memberForm.get('dateOfBirth')?.invalid &&
          memberForm.get('dateOfBirth')?.touched
        "
      >
        Date of Birth is required
      </div>
    </label>
    <label>
      Sponsor ID
      <input
        type="text"
        formControlName="sponsorId"
        placeholder="Enter Sponsor ID"
        readonly
        tabindex="-1"
        style="
          pointer-events: none;
          background-color: #f5f5f5;
          border-color: #f5f5f5;
        "
      />
    </label>

    <label>
      Mobile Number
      <input
        type="text"
        formControlName="mobileNumber"
        placeholder="Enter Mobile Number"
        required
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('mobileNumber')?.invalid &&
          memberForm.get('mobileNumber')?.touched
        "
      >
        Mobile Number is required and must be 10 digits
      </div>
    </label>

    <label>
      Insurance Class
      <select formControlName="insuranceClass">
        <option
          *ngFor="let classOption of insuranceClasses"
          [value]="classOption"
        >
          {{ classOption }}
        </option>
      </select>
      <div
        class="error"
        *ngIf="
          memberForm.get('insuranceClass')?.invalid &&
          memberForm.get('insuranceClass')?.touched
        "
      >
        Insurance class is required.
      </div>
    </label>

    <label>
      Gender
      <select formControlName="gender">
        <option value="">-- Select Gender --</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </select>
      <div
        class="error"
        *ngIf="
          memberForm.get('gender')?.invalid && memberForm.get('gender')?.touched
        "
      >
        Gender is required.
      </div>
    </label>

    <label>
      Name (Arabic)
      <input
        type="text"
        formControlName="nameArabic"
        placeholder="Enter Arabic Name"
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('nameArabic')?.invalid &&
          memberForm.get('nameArabic')?.touched
        "
      >
        Arabic name is required.
      </div>
    </label>

    <label>
      First name (English)
      <input
        type="text"
        formControlName="firstNameEnglish"
        placeholder="Enter First Name English"
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('firstNameEnglish')?.invalid &&
          memberForm.get('firstNameEnglish')?.touched
        "
      >
        English name is required.
      </div>
    </label>

    <label>
      Last name (English)
      <input
        type="text"
        formControlName="lastNameEnglish"
        placeholder="Enter Last Name English"
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('lastNameEnglish')?.invalid &&
          memberForm.get('lastNameEnglish')?.touched
        "
      >
        English name is required.
      </div>
    </label>

    <label *ngIf="!isDependent">
      Job Title
      <input
        type="text"
        formControlName="jobTitle"
        placeholder="Enter Job Title"
      />
      <div
        class="error"
        *ngIf="
          memberForm.get('jobTitle')?.invalid &&
          memberForm.get('jobTitle')?.touched
        "
      >
        Job title is required.
      </div>
    </label>

    <label *ngIf="isDependent">
      Relationship
      <select formControlName="relation">
        <option value="">-- Select Relationship --</option>
        <option value="spouse">Spouse</option>
        <option value="child">Child</option>
        <option value="parent">Parent</option>
        <option value="sibling">Sibling</option>
        <option value="other">Other</option>
      </select>
      <div
        class="error"
        *ngIf="
          memberForm.get('relation')?.invalid &&
          memberForm.get('relation')?.touched
        "
      >
        Relationship is required.
      </div>
    </label>

    <label>
      Married Status
      <select formControlName="isMarried">
        <option value="">-- Select Status --</option>
        <option value="false">No</option>
        <option value="true">Yes</option>
      </select>
      <div
        class="error"
        *ngIf="
          memberForm.get('isMarried')?.invalid &&
          memberForm.get('isMarried')?.touched
        "
      >
        Married status is required.
      </div>
    </label>

    <div class="form-actions">
      <button *ngIf="isEdit" type="submit" class="save-btn">Save</button>
      <button *ngIf="!isEdit && !isDependent" type="submit" class="save-btn">
        Add Member
      </button>
      <button *ngIf="!isEdit && isDependent" type="submit" class="save-btn">
        Add Dependent
      </button>
    </div>
  </form>
</div>
